import { render, staticRenderFns } from "./FieldsBlock.vue?vue&type=template&id=ecbaf860&scoped=true"
import script from "./FieldsBlock.vue?vue&type=script&lang=js"
export * from "./FieldsBlock.vue?vue&type=script&lang=js"
import style0 from "./FieldsBlock.vue?vue&type=style&index=0&id=ecbaf860&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecbaf860",
  null
  
)

export default component.exports